import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "31",
  height: "31",
  viewBox: "0 0 31 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M26.75 26.9092L21.3125 21.4717M14.25 8.15918C17.7018 8.15918 20.5 10.9574 20.5 14.4092M24.25 14.4092C24.25 19.932 19.7728 24.4092 14.25 24.4092C8.72715 24.4092 4.25 19.932 4.25 14.4092C4.25 8.88633 8.72715 4.40918 14.25 4.40918C19.7728 4.40918 24.25 8.88633 24.25 14.4092Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }